import Vue from 'vue'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import VXETablePluginAntd from 'vxe-table-plugin-antd'
import 'vxe-table-plugin-antd/dist/style.css'

VXETable.setup({
  // 默认表格参数
  size: 'mini',
  table: {
    showOverflow: 'tooltip',
    showHeaderOverflow: 'tooltip',
    showFooterOverflow: 'tooltip',
    resizable: true,
    fit: true,
    headeAlign: 'left',
    align: 'left',
    highlightCurrentRow: true,
    highlightHoverRow: true
  }
})

VXETable.use(VXETablePluginAntd)
Vue.use(VXETable)
